(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('flyerDetailItems', {
            templateUrl: 'app/admin/flyers/flyer-detail/details-panel/flyer-detail-items.html',
            controller: flyerDetailItemsController,
            bindings: {
                flyer: '<',
                isImmoContext: '<',
                detailItemsState: '=',
                defaultItemsState: '<',
            },
            controllerAs: 'vm'
        });

    /** @ngInject */
    function flyerDetailItemsController(flyersConstants) {
        var vm = this;

        vm.variationsState = flyersConstants.FLYER_DETAIL_ITEMS_STATE.VARIATIONS;
        vm.picturesState = flyersConstants.FLYER_DETAIL_ITEMS_STATE.PICTURES;
        vm.flyerDetailContentId = 'flyerDetailContent';

        vm.modalBack = modalBack;

        function modalBack() {
            vm.detailItemsState = vm.defaultItemsState;
        }
    }
})();
